// import { Icons } from '@vouched.id/vault';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGlobalState } from 'store/reducers/reducer';
export const PrivateRouteAccountStatus = () => {
    const { state } = useGlobalState();
    const { account, user } = state;
    const { pathname } = useLocation();
    if (account && !(!!user?.isSupport || !!user?.isAdmin)) {
        if (account.setupStatus === 'UNVERIFIED_EMAIL' &&
            pathname !== '/account/needs-verification') {
            return React.createElement(Navigate, { replace: true, to: "/account/needs-verification" });
        }
        if (account.setupStatus === 'INCOMPLETE_ACCOUNT_INFO' &&
            pathname !== '/account/update-account-info') {
            return React.createElement(Navigate, { replace: true, to: "/account/update-account-info" });
        }
    }
    return React.createElement(Outlet, null);
};
